import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Breadcrumb, HeroBanner, PartnerList, SanitizedHtml, Skeleton } from 'components';
import { useFetch } from 'hooks';
import { routes } from 'router';
import { appService } from 'services';
import { setFooterBanner } from 'store';

import 'assets/styles/components/pages/partners.scss';

const PartnersPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { call, data: partnersResponse, loading } = useFetch({ filterUserCompany: true });

  useEffect(() => {
    getPartnersContent();
  }, []);

  useEffect(() => {
    const footerBanner = partnersResponse?.data?.[0]?.helpBanner;

    if (!isEmpty(footerBanner)) {
      dispatch(setFooterBanner(footerBanner));
    }
  }, [partnersResponse]);

  const getPartnersContent = () => {
    call({
      service: appService.getStrapiServiceName(),
      method: 'get',
      path: '/api/partners-pages',
      query: { populate: 'deep,4' }
    });
  };

  const partnersData = partnersResponse?.data?.[0];

  return (
    <>
      <HeroBanner
        title={partnersData?.heroTitle || ''}
        image={partnersData?.heroImageDesktop}
        mobileImage={partnersData?.heroImageMobile}
        loading={loading}
      />

      <div className="main-container pt-8 lg:pt-20 bg-gray-50 lg:bg-white">
        <div className="mb-8">
          <Breadcrumb
            breadcrumbItems={[
              { label: t('breadcrumb.home'), url: routes.home.path },
              { label: t('breadcrumb.partners') }
            ]}
          />
        </div>

        {!loading && (
          <>
            <h2 className="h1 underlined-yellow mb-8">{partnersData?.pageTitle}</h2>
            {partnersData?.content && (
              <SanitizedHtml content={partnersData?.content} className="text-sm mb-4 lg:mb-8 lg:text-base" />
            )}

            {!isEmpty(partnersData?.partners) && <PartnerList partners={partnersData.partners} />}
          </>
        )}

        {loading && (
          <>
            <Skeleton type="text" classNames="h-8 w-full" />
            <Skeleton type="text" classNames="h-8 w-[50%] mb-8" />

            {[...Array(5)].map((_, index) => (
              <div
                key={`travel-skeleton-${index}`}
                className="w-full h-40 rounded-xl mb-8 lg:flex lg:items-center lg:gap-4"
              >
                <Skeleton
                  type="square"
                  size="xl"
                  classNames="h-full w-full lg:aspect-video lg:w-[14.38rem] lg:rounded-xl"
                />

                <div className="hidden lg:block lg:w-full">
                  <Skeleton type="text" size="xs" classNames="w-full lg:w-[25%] lg:h-8" />
                  <Skeleton type="text" size="xs" classNames="w-full lg:w-[20%] lg:h-8" />
                  <Skeleton type="text" size="xs" classNames="w-full lg:w-[25%] lg:h-8" />
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default PartnersPage;
